export default __webpack_public_path__ + "static/media/img.a6838792.png";